import { Prismic, isEmptyText } from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import React from 'react';
import { EventRegistration } from '../components/event-registration/EventRegistration';

interface IProps {
  event_id: Prismic.RichText;
  image: Prismic.Image;
  description: Prismic.RichText;
  use_kennitala: boolean;
  use_phonenumber: boolean;
  use_company_name: boolean;
  use_company_kennitala: boolean;
  max_number_registering: number;
  max_number_registering_label: Prismic.RichText;
  fields: IFields[];
  title: Prismic.RichText;
}

interface IFields {
  field_name: Prismic.RichText;
  field_type: string;
  field_position: string;
  field_size: string;
}

export const EventRegistrationContainer = ({
  event_id,
  image,
  title,
  max_number_registering_label,
  max_number_registering,
  ...rest
}: IProps) => {
  if (isEmptyText(event_id)) {
    return null;
  }
  return (
    <Segment>
      <EventRegistration
        {...rest}
        title={Prismic.text(title) ?? ''}
        event_id={Prismic.text(event_id) ?? ''}
        max_number_registering_label={
          Prismic.text(max_number_registering_label) ?? ''
        }
        max_number_registering={
          max_number_registering === null ? 1 : max_number_registering
        }
        image={image}
      />
    </Segment>
  );
};
